module.exports = __webpack_public_path__ + "static/media/22ESCWA4.668e13db.jpg";